'use client'

import { useFavorites } from '../context/FavoritesProvider'
import type { FavoriteProps } from '../types/types'
import { FavoriteButton } from './FavoriteButton'

export const Favorite = (props: FavoriteProps) => {
	const { enabled } = useFavorites()

	return enabled ? <FavoriteButton {...props} /> : null
}
